import { useState } from "react";
import BaseTabs from "../../components/common/base-tabs/base-tabs";
import BaseTitle from "../../components/common/base-title/base-title";
import { Container, Grid, List, ListItem, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";
import { ContactForm } from "../../components/view/study-abroad/contact-form";
import { ContactAtripa } from "../../components/view/study-abroad/contact-atripa";
import { TabsContent } from "../../components/view/study-abroad/tab-content";

export default function StudyAbroad() {
    const { t } = useTranslation();
    //handle tab change
    const [activeTab, setActiveTab] = useState({
        russia: true,
        france: false,
        germany: false,
        italy: false,
    });

    const handleTabChange = type => {
        setActiveTab({ [type]: true });
    };

    const countrylist = [
        {
            type: "russia",
            title: t("Study Abroad.Russia"),
            activeTab: activeTab?.russia,
            icon: "RussiaFlag",
            inactive: "AirplanInactiveIcon",
            content: {
                title: "چرا روسیه را برای تحصیل انتخاب کنیم؟",
                description:
                    "تحصیل در روسیه یکی از مقرون‌به‌صرفه‌ترین مسیرهای مهاجرت تحصیلی برای دانشجویان ایرانی است. دانشگاه‌های روسیه در رشته‌های پزشکی، دندانپزشکی، داروسازی، مهندسی و علوم پایه از اعتبار بالایی برخوردار بوده و بسیاری از آن‌ها در رتبه‌بندی‌های جهانی حضور دارند.",
                items: [
                    " شهریه مناسب نسبت به بسیاری از کشورهای اروپایی و آمریکایی",
                    " امکان دریافت ویزا روسیه بدون سخت گیری های معمول سفارتی ",
                    "امکان تحصیل به زبان روسی یا انگلیسی در بسیاری از رشته‌ها",
                    "هزینه زندگی پایین‌تر نسبت به اکثر کشورهای اروپای غربی",
                    " عدم نیاز به آزمون‌های پیچیده ورودی در بسیاری از رشته‌ها",
                    "فرصت دریافت بورسیه‌های دولتی روسیه",
                    "اعتبار بین‌المللی بسیاری از دانشگاه‌های روسیه",
                    "فرصت آشنایی با یکی از بزرگ‌ترین اقتصادها و فرهنگ‌های جهان",
                ],
            },
        },
        {
            type: "france",
            title: t("Study Abroad.France"),
            activeTab: activeTab?.france,
            icon: "FranceFlag",
            content: {
                title: "چرا فرانسه را برای تحصیل انتخاب کنیم؟",
                description:
                    "فرانسه یکی از قدرتمندترین کشورهای جهان در حوزه آموزش عالی است و سالانه میزبان صدها هزار دانشجوی بین‌المللی از سراسر دنیا می‌باشد.امکان حضور در یکی از کشور های معتبر اروپایی فرصتی بی‌نظیر برای دانشجو خواهد بود.",
                items: [
                    "دانشگاه‌ها و مؤسسات آموزشی با اعتبار جهانی",
                    "هزینه تحصیل مناسب در دانشگاه‌های دولتی",
                    "فرصت‌های گسترده دریافت بورسیه",
                    "امکان تحصیل به زبان فرانسوی یا انگلیسی",
                    "بازار کار قدرتمند و فرصت‌های شغلی متنوع",
                    "امکان کار دانشجویی حین تحصیل",
                    "دسترسی به کل منطقه شنگن",
                    "کیفیت بالای زندگی و خدمات عمومی",
                    "حضور شرکت‌های بزرگ بین‌المللی و فرصت‌های کارآموزی ارزشمند",
                    "اعتبار بالای مدارک دانشگاهی فرانسه در سراسر جهان",
                ],
            },
        },
        {
            type: "germany",
            title: t("Study Abroad.Germany"),
            activeTab: activeTab?.germany,
            icon: "GermanyFlag",
            content: {
                title: "چرا آلمان را برای تحصیل انتخاب کنیم؟",
                description:
                    "آلمان یکی از محبوب‌ترین مقاصد تحصیلی جهان و بزرگ‌ترین اقتصاد اروپا است. دانشگاه‌های آلمان به دلیل کیفیت آموزشی بالا و ارتباط نزدیک با صنعت شهرت جهانی دارند.همچنین امکان جذب دانشجویان پس از فارغ التحصیلی در راستای همین ارتباط بین صنعت و دانشگاه نقطه عطف انتخاب آلمان برای تحصیل خواهد بود.",
                items: [
                    "شهریه بسیار پایین یا رایگان در بسیاری از دانشگاه‌های دولتی",
                    "کیفیت آموزشی بسیار بالا و استانداردهای جهانی",
                    "تنوع گسترده رشته‌های تحصیلی به زبان انگلیسی و آلمانی",
                    "امکان کار دانشجویی در طول تحصیل",
                    "فرصت‌های شغلی گسترده پس از فارغ‌التحصیلی",
                    "نرخ پایین بیکاری و بازار کار قدرتمند",
                    "امکان دریافت اقامت کاری پس از اتمام تحصیل",
                    "دانشگاه‌های مطرح در رشته‌های مهندسی، فناوری، علوم و مدیریت",
                    "دسترسی به کشورهای اروپایی و حوزه شنگن",
                    "اعتبار بالای مدرک دانشگاهی در سراسر جهان",
                ],
            },
        },
        {
            type: "italy",
            title: t("Study Abroad.Italy"),
            activeTab: activeTab?.italy,
            icon: "ItalyFlag",
            content: {
                title: "چرا ایتالیا را برای تحصیل انتخاب کنیم؟",
                description:
                    "ایتالیا یکی از محبوب‌ترین مقاصد تحصیلی دانشجویان ایرانی است. دانشگاه‌هایی با سابقه ای معتبر، شهریه مناسب دولتی و بورسیه‌های استانی باعث شده‌اند ایتالیا به یکی از جذاب‌ترین گزینه‌های تحصیل در اروپا تبدیل شود.",
                items: [
                    "امکان دریافت بورسیه‌های استانی بر اساس شرایط مالی دانشجو",
                    "دانشگاه‌های معتبر با سابقه چندصد ساله",
                    "شهریه پایین‌تر نسبت به بسیاری از کشورهای اروپایی",
                    "ارائه صدها رشته به زبان انگلیسی",
                    "امکان سفر آزادانه در حوزه شنگن",
                    "اجازه کار دانشجویی در کنار تحصیل",
                    "فرصت تبدیل اقامت تحصیلی به اقامت کاری پس از فارغ‌التحصیلی",
                    "کیفیت بالای زندگی، فرهنگ غنی و امنیت اجتماعی مناسب",
                    "مقصدی ایده‌آل برای رشته‌های معماری، طراحی، هنر، مهندسی و مدیریت",
                ],
            },
        },
    ];

    return (
        <Container maxWidth="xl">
            <BaseTitle title={t("Study Abroad.Study Abroad")} />
            <Grid container columnGap={2} alignItems="flex-start" mt={{ xs: 0, md: 5 }}>
                <Grid container item md={7.5} rowGap={6} mb={5}>
                    <Grid container rowGap={2}>
                        <BaseTabs list={countrylist} handleTabChange={handleTabChange} />
                        {countrylist.map(item => !!item.type === activeTab[item.type] && <TabsContent data={item?.content} />)}
                    </Grid>

                    <Grid container rowGap={2}>
                        <BaseTitle title={"درباره آتریپا"} />
                        <Typography
                            component="p"
                            textAlign="justify"
                            lineHeight="2rem"
                            color={"var(--dark-gray)"}
                            fontSize={{ xs: "0.875rem", md: "1rem" }}
                        >
                            آتریپا نام تجاری شرکت پیشگام پرتو گشت ویرا است که با هدف ارائه خدمات تخصصی در حوزه مهاجرت تحصیلی و اعزام دانشجو به خارج از
                            کشور فعالیت می‌کند.ما با تکیه بر دانش به‌روز، تجربه عملی و شناخت دقیق از سیستم‌های آموزشی کشورهای مختلف، تلاش می‌کنیم مسیر
                            مهاجرت تحصیلی را برای متقاضیان شفاف، مطمئن و قابل برنامه‌ریزی کنیم. خدمات آتریپا شامل مشاوره تخصصی انتخاب کشور و رشته، اخذ
                            پذیرش تحصیلی، راهنمایی در فرآیند دریافت ویزا، بررسی فرصت‌های بورسیه و همراهی متقاضیان از اولین مرحله تصمیم‌گیری تا ورود به
                            دانشگاه مقصد است. ما باور داریم که هر دانشجو شرایط، اهداف و مسیر منحصربه‌فرد خود را دارد. به همین دلیل تمامی خدمات و
                            مشاوره‌های ما بر اساس شرایط واقعی هر متقاضی ارائه می‌شود تا بهترین گزینه متناسب با اهداف تحصیلی و آینده شغلی او انتخاب
                            گردد.
                        </Typography>
                    </Grid>
                    <Grid container rowGap={2}>
                        <BaseTitle title={"چرا آتریپا؟"} />
                        <List sx={{ color: "var(--dark-gray)" }}>
                            <ListItem sx={listStyle}>✓ مشاوره تخصصی و صادقانه</ListItem>
                            <ListItem sx={listStyle}>✓ بررسی دقیق شرایط هر متقاضی</ListItem>
                            <ListItem sx={listStyle}>✓ ارائه راهکارهای متناسب با بودجه و اهداف دانشجو</ListItem>
                            <ListItem sx={listStyle}>✓ همراهی مرحله به مرحله تا اخذ پذیرش و ویزا</ListItem>
                            <ListItem sx={listStyle}>✓ آشنایی کامل با فرآیندهای تحصیل در کشورهای روسیه، ایتالیا، آلمان و فرانسه</ListItem>
                            <ListItem sx={listStyle}>✓ پاسخگویی و پشتیبانی مستمر در طول فرآیند مهاجرت تحصیلی</ListItem>
                        </List>

                        <Typography
                            component="p"
                            textAlign="justify"
                            lineHeight="2rem"
                            color={"var(--dark-gray)"}
                            fontSize={{ xs: "0.875rem", md: "1rem" }}
                        >
                            هدف ما تنها دریافت پذیرش دانشگاه نیست؛ بلکه کمک به ساختن آینده‌ای روشن‌تر برای دانشجویانی است که قصد ادامه تحصیل و پیشرفت
                            در سطح بین‌المللی را دارند.
                        </Typography>
                        <Typography
                            component="h3"
                            color={"var(--primary-color)"}
                            fontSize={{ xs: "1.25rem", md: "1.5rem" }}
                            fontWeight="bold"
                            textAlign="justify"
                        >
                            آتریپا همراه مطمئن شما در مسیر مهاجرت تحصیلی
                        </Typography>
                    </Grid>
                    <ContactAtripa />
                </Grid>
                <ContactForm endPoint="/visa/scholar/contact-request/" />
            </Grid>
        </Container>
    );
}

export const listStyle = { fontSize: { xs: "0.875rem", md: "1rem" }, textAlign: "justify", padding: { xs: "4px", md: "8px" } };
